import React from 'react';
import PropTypes from 'prop-types';
import ImageUploadOverlay from '../ImageUploadOverlay';

/**
 * Display-specific wrapper around the shared ImageUploadOverlay.
 * Receives clip-path and canvas size from the per-product config
 * passed down by the parent (ProductImageView / Customise).
 */
const DisplayImageUploadOverlay = ({
    imageData = null,
    onCompositeGenerated = () => {},
    displayImageSrc = '',
    clipPathPoints = [],
    canvasSize = 480,
    showDevMode = false,
    isProductAddedToBuild = false,
}) => (
    <ImageUploadOverlay
        imageData={imageData}
        onCompositeGenerated={onCompositeGenerated}
        baseImageSrc={displayImageSrc}
        clipPathPoints={clipPathPoints}
        canvasSize={canvasSize}
        showDevMode={showDevMode}
        isProductAddedToBuild={isProductAddedToBuild}
        overlayClassName="display-image-upload-overlay"
        clipBackgroundColor="white"
    />
);

DisplayImageUploadOverlay.propTypes = {
    imageData: PropTypes.shape({
        dataUri: PropTypes.string,
        compositeDataUri: PropTypes.string,
        productId: PropTypes.string,
        position: PropTypes.shape({
            x: PropTypes.number,
            y: PropTypes.number,
            scale: PropTypes.number,
        }),
    }),
    onCompositeGenerated: PropTypes.func,
    displayImageSrc: PropTypes.string,
    clipPathPoints: PropTypes.oneOfType([
        PropTypes.arrayOf(
            PropTypes.shape({
                x: PropTypes.number.isRequired,
                y: PropTypes.number.isRequired,
            })
        ),
        PropTypes.shape({
            type: PropTypes.string.isRequired,
            css: PropTypes.string.isRequired,
            commands: PropTypes.array.isRequired,
        }),
    ]),
    canvasSize: PropTypes.number,
    showDevMode: PropTypes.bool,
    isProductAddedToBuild: PropTypes.bool,
};

export default DisplayImageUploadOverlay;
